export default __webpack_public_path__ + "static/media/Quiken_Telefono-49.ef6430ef.svg";